


document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('header-menu .mega-menu').forEach(megaMenuHolder => {
    let summary = megaMenuHolder.querySelector(':scope > summary');
    
    megaMenuHolder.addEventListener('mouseover', function () {
      if (window.innerWidth > 992) {
        this.setAttribute('open', true);
        summary.setAttribute('aria-expanded', false);
      }
    });
    
    megaMenuHolder.addEventListener('mouseout', function () {
      if (window.innerWidth > 992) {
        this.removeAttribute('open');
        summary.setAttribute('aria-expanded', true);
      }
    });
  });
});

// announcement bar timer
(function () {
    if (document.getElementById("countdown-timer")) {
      document.addEventListener("DOMContentLoaded", () => {
        const countdownElement = document.getElementById("countdown-timer");
        if (!countdownElement) return;
      
        const countdownElementInner = countdownElement.querySelector(".countdown__inner");
      
        // Функция для расчета времени до полуночи
        const calculateTimeToMidnight = () => {
          const now = new Date();
          const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      
          const distance = midnight - now;
      
          const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
          return { hours, minutes, seconds };
        };
      
        // Обновление таймера каждую секунду
        const x = setInterval(() => {
          const { hours, minutes, seconds } = calculateTimeToMidnight();
      
          document.getElementById("hours").innerText = hours;
          document.getElementById("minutes").innerText = minutes;
          document.getElementById("seconds").innerText = seconds;
      
          countdownElementInner.classList.remove('hidden');
        }, 1000);
      
        // Функция для вычисления и установки верхнего отступа
        const calculateStickyTop = () => {
          const header = document.querySelector('.section-header');
          const announcementBarHeight = document.querySelector('.announcement-bar-section').scrollHeight;
          if (header) {
            header.style.top = `${announcementBarHeight - 1}px`;
          }
        };
      
        window.addEventListener('resize', calculateStickyTop);
        calculateStickyTop();
      });
      

    }
})();
// announcement bar timer

// product gallery
(function () {
  if (document.querySelector('.main-slider')) {
    document.addEventListener('DOMContentLoaded', function () {
      var thumbSlider = new Swiper('.thumb-slider', {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      });
    
      var mainSlider = new Swiper('.main-slider', {
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        thumbs: {
          swiper: thumbSlider,
        },
        pagination: {
          el: '.swiper-pagination',
        },
      });
    
      var popupSlider = new Swiper('.popup-slider', {
        spaceBetween: 10,
        navigation: {
          nextEl: '.popup-gallery .swiper-button-next',
          prevEl: '.popup-gallery .swiper-button-prev',
        },
        zoom: true,
      });
    
      // Открытие попапа при клике на основное изображение
      document.querySelectorAll('.main-slider .swiper-slide img').forEach(function (image, index) {
        image.addEventListener('click', function () {
          popupSlider.slideTo(index);
          document.getElementById('popup-gallery').style.display = 'flex';
        });
      });
    
      // Закрытие попапа
      document.querySelector('.popup-close').addEventListener('click', function () {
        document.getElementById('popup-gallery').style.display = 'none';
      });

      // Закрытие попапа по клику на пустое место
      document.getElementById('popup-gallery').addEventListener('click', function (event) {
          if (event.target === this) {
          this.style.display = 'none';
          }
      });

      // Листание галереи с помощью стрелок на клавиатуре
      document.addEventListener('keydown', function (event) {
          if (document.getElementById('popup-gallery').style.display === 'flex') {
              if (event.key === 'ArrowRight') {
                  popupSlider.slideNext();
              } else if (event.key === 'ArrowLeft') {
                  popupSlider.slidePrev();
              }
          }
          if (document.getElementById('popup-gallery').style.display != 'flex') {
              if (event.key === 'ArrowRight') {
                  mainSlider.slideNext();
              } else if (event.key === 'ArrowLeft') {
                  mainSlider.slidePrev();
              }
          }
      });
    });
  }
  
})();
// product gallery

// open product customizer
(function () {
  
  const dialog = document.querySelectorAll('dialog')
  const openDialog = document.querySelectorAll('.open_dialog')
  const closeDialog = document.querySelectorAll('.close_dialog')
  const customizer = document.querySelector('.product_customizer')
  const initialsInput = document.querySelector('.product_customizer__input')
  const initialsText = document.querySelector('#product_customizer__text_value')
  const initialsInputError = document.querySelector('.error-input')
  const positionInputs = document.querySelectorAll('.product_customizer__position input')
  const colorInputs = document.querySelectorAll('.product_customizer__colors input')
  const addToCartButton = document.querySelector('.product_customizer .product_customizer__submit')
  const addInitialsButton = document.querySelector('.product_customizer__button')

 

  if (dialog) {
    openDialog.forEach(el => {
      el.addEventListener('click', () => {
        const target = el.dataset.dialog
        dialog.forEach(element => {
          if (element.dataset.dialog == target) {
            element.showModal();
            document.body.classList.add("overflow-hidden");
          }
        })
      })
    })
  
    closeDialog.forEach(el => {
      el.addEventListener('click', () => {
        const target = el.dataset.dialog
        dialog.forEach(element => {
          element.close()
          document.body.classList.remove("overflow-hidden");
        })
      })
    })
  
    const handleModalClick = ({ currentTarget, target }) => {
      const isClickedOnBackdrop = target === currentTarget;
    
      if (isClickedOnBackdrop) {
        currentTarget.close();
        document.body.classList.remove("overflow-hidden");
      }
    }
  
    dialog.forEach(el => {
      el.addEventListener("click", handleModalClick);
    }) 
  }

  if (addInitialsButton) {
    function showError() {
      if (initialsInput.validity.patternMismatch) {
          initialsInputError.textContent = document.querySelector('.error-input-hidden-pattern').textContent
      } else if (initialsInput.validity.tooShort || initialsInput.value.length < 1) {
        initialsInputError.textContent = document.querySelector('.error-input-hidden-short').textContent;
      } 
      
      initialsInputError.className = 'error-input active';
      initialsInput.focus();
    }
  
    initialsInput.addEventListener('input', () => {
  
      if (initialsInput.validity.valid) {
        initialsInput.value = initialsInput.value.toUpperCase();
        
        initialsText.textContent = initialsInput.value
        initialsText.dataset.before = initialsInput.value
        initialsInputError.className = 'error-input';
      }
      if (initialsInput.value.length == 0) {
        initialsInputError.className = 'error-input';
      }
      if (initialsInput.value.length > 0 && initialsInput.validity.valid) {
        addToCartButton.removeAttribute('disabled')
      } else {
        addToCartButton.setAttribute('disabled', true)
      }
      if (!initialsInput.validity.valid) {
        setTimeout(() => {
          showError();
        }, 50);
      }
    })
  
    const checkAttributes = () => {
      const colorInput = document.querySelector('.product_customizer__colors input:checked').getAttribute('id')    
      initialsText.classList = ''
      if (positionInputs.length) {
        const positionInput = document.querySelector('.product_customizer__position input:checked').getAttribute('id') 
        initialsText.classList.add(colorInput, positionInput)     
      } else {
        initialsText.classList.add(colorInput)
      }
    
    }
  
    if (positionInputs.length) {
      positionInputs.forEach(input => {
        input.addEventListener('change', () => {
          checkAttributes()
        })
      })
    }
  
    colorInputs.forEach(input => {
      input.addEventListener('change', () => {
        checkAttributes()
      })
    })
  
    checkAttributes() 
  }
})(); 
// open product customizer 

// custom select
(function () {
  const selects = document.querySelectorAll(".custom-select")
  if (selects) {
    document.addEventListener("DOMContentLoaded", function () {
      selects.forEach(function (select) {
        const button = select.querySelector(".custom-select__button");
        const list = select.querySelector(".custom-select__list");
        
        button.addEventListener("click", function (event) {
          event.stopPropagation();
          selects.forEach(s => {
            if (s !== select) s.classList.remove("open");
          });
          select.classList.toggle("open");
        });
        
        document.addEventListener("click", function (event) {
          if (!select.contains(event.target)) {
            select.classList.remove("open");
          }
        });
      });
    });    
  }
})();
// custom select